/**
 * InboxEmptyState
 * Clean, minimal empty state.
 */

import { Button } from '@/components/ui/button';

import type { CorrespondencePackageType } from '../types';
import { CreatePackageButton } from './CreatePackageButton';

interface InboxEmptyStateProps {
  hasFilters: boolean;
  onClearFilters: () => void;
  onCreatePackage?: (type: CorrespondencePackageType) => void;
  isCreating?: boolean;
}

export const InboxEmptyState: React.FC<InboxEmptyStateProps> = ({
  hasFilters,
  onClearFilters,
  onCreatePackage,
  isCreating,
}) => (
  <div className="flex flex-col items-center justify-center py-20 px-4">
    <div className="text-4xl mb-4">📬</div>
    <h3 className="text-base font-medium text-stone-900 mb-1">
      {hasFilters ? 'No matches' : 'No correspondence'}
    </h3>
    <p className="text-sm text-stone-500 text-center max-w-xs mb-6">
      {hasFilters
        ? 'Try adjusting your filters.'
        : 'Draft and send letters, faxes, and emails.'}
    </p>

    {hasFilters ? (
      <Button variant="outline" size="sm" onClick={onClearFilters}>
        Clear filters
      </Button>
    ) : onCreatePackage ? (
      <CreatePackageButton onSelect={onCreatePackage} isLoading={isCreating} />
    ) : null}
  </div>
);
